export const PLANS = [
  {
    key: "limited",
    title: "النسخة المحدودة",
    popular: true,
    desc: "توفر أساسيات إدارة المشتريات والمبيعات...",
    price: 1499,
    period: "مدى الحياة",
    features: [
      "إدارة المبيعات",
      "إدارة المشتريات",
      "إدارة المخزون",
      "العملاء والموردين",
      "سندات القبض والصرف",
      "إدارة المستخدمين والصلاحيات",
    ],
    waText: "أريد الحصول على النسخة المحدودة",
  },
  {
    key: "full",
    title: "النسخة الكاملة",
    popular: false,
    desc: "حل شامل يضم جميع أدوات المحاسبة...",
    price: 3999,
    period: "مدى الحياة",
    features: [
      "جميع ميزات النسخة المحدودة",
      "شجرة الحسابات",
      "القيود اليومية",
      "سندات القبض والصرف المجمعة",
      "قائمة الدخل",
      "كشف حساب عام",
    ],
    waText: "أريد الحصول على النسخة الكاملة",
  },
  {
    key: "restaurants",
    title: "نسخة المطاعم",
    popular: false,
    desc: "مصممة خصيصًا لإدارة طلبات المطاعم.",
    price: 1499,
    period: "مدى الحياة",
    features: [
      "ادارة المنيو",
      "إدارة الأقسام والطابعات",
      "إدارة المرتجعات",
      "مبيعات الأصناف",
      "المستخدمين والصلاحيات",
      "تقارير عامة",
    ],
    waText: "أريد الحصول على نسخة المطاعم",
  },
];
